// src/components/WhyChooseUs.js
import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  VStack,
  HStack,
  Icon,
  Image,
  useColorModeValue,
  Circle,
} from '@chakra-ui/react';
import { ArrowForwardIcon, TriangleUpIcon } from '@chakra-ui/icons';
// Importing icons for the features
import { GoGear, GoPeople, GoTrophy } from 'react-icons/go';
import { BiTimeFive } from 'react-icons/bi';
import group_photo from '../assets/group_photo.jpg';
import { Link as RouterLink } from 'react-router-dom'; // <<< ADD THIS IMPORT

// A reusable component for each feature item in the list
const FeatureItem = ({ icon, title, children }) => {
  return (
    <HStack align="flex-start" spacing={4}>
      <Icon as={icon} boxSize={8} color="orange.400" mt={1} />
      <VStack align="flex-start" spacing={1}>
        <Text fontWeight="bold">{title}</Text>
        <Text fontSize="sm" color="gray.300">{children}</Text>
      </VStack>
    </HStack>
  );
};


export default function WhyChooseUs() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const cardBgColor = useColorModeValue('blue.800', 'blue.700');

  return (
    <Box as="section" bg={bgColor} py={{ base: 16, md: 24 }}>
      <Box maxW="7xl" mx="auto" px={8}>
        
        {/* Section Header (Optional, as the design seems to merge it into the main content) */}

        <Flex
          direction={{ base: 'column', lg: 'row' }}
          align="center"
          gap={12}
        >
          {/* Left Side: Image with Play Button */}
          <Box flex="1" position="relative" w="full">
            <VStack align="flex-start" spacing={4} mb={8}>
              <Text color="orange.500" fontWeight="bold">Why Choose Us</Text>
              <Heading as="h2" size="2xl" fontWeight="bold">
                Building Trust, Delivering Excellence
              </Heading>
            </VStack>
            <Box position="relative" borderRadius="lg" overflow="hidden">
              <Image
                src={group_photo}
                alt="Construction team planning a project"
                w="full"
              />
              <Circle
                as="button"
                size="80px"
                bg="whiteAlpha.800"
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                transition="all 0.3s"
                _hover={{ bg: 'white' }}
              >
                <TriangleUpIcon boxSize={8} color="blue.800" transform="rotate(90deg)" />
              </Circle>
            </Box>
          </Box>

          {/* Right Side: Features List */}
          <VStack
            flex="1"
            bg={cardBgColor}
            color="white"
            p={10}
            borderRadius="lg"
            spacing={8}
            align="flex-start"
            w="full"
          >
            <FeatureItem icon={GoGear} title="Advanced Technology">
Our firm stays ahead of the curve by integrating the latest construction technologies and innovative building methods.
            </FeatureItem>
            <FeatureItem icon={GoPeople} title="Expert Team">
           Our certified professionals bring decades of combined experience and a shared commitment to exceptional craftsmanship.

            </FeatureItem>
            <FeatureItem icon={BiTimeFive} title="On-Time Delivery">
            Through meticulous planning and project management, we have a proven track record of completing projects on schedule.
            </FeatureItem>
            <FeatureItem icon={GoTrophy} title="Award Winning">
            Our dedication to quality and safety has been recognized with multiple industry awards for building excellence.
            </FeatureItem>
            
            <Button
              alignSelf="flex-start"
              rightIcon={<ArrowForwardIcon />}
              colorScheme="orange"
              variant="solid"
               as={RouterLink}          // <<-- ADD THIS
              to="/why-choose-us"  
            >
              Learn More
            </Button>
          </VStack>
        </Flex>
      </Box>
    </Box>
  );
}